import api from '../lib/axios';
export async function getCustomTiles() {
    const { data } = await api.get('/api/admin/custom-tiles');
    return data.data;
}
export async function getCustomTile(id) {
    const { data } = await api.get(`/api/admin/custom-tiles/${id}`);
    return data.data;
}
export async function createCustomTile(body) {
    const { data } = await api.post('/api/admin/custom-tiles', body);
    return data.data;
}
export async function updateCustomTile(id, body) {
    const { data } = await api.patch(`/api/admin/custom-tiles/${id}`, body);
    return data.data;
}
export async function deleteCustomTile(id) {
    await api.delete(`/api/admin/custom-tiles/${id}`);
}
